export default {
  menu: {
    "Large font": "Large font",
    "Default font": "Default font",
    "Total Amonut": "Total Amonut",
    "Decimal bill": "Decimal bill",
    "Service Fee": "Service Fee",
    "Thank You For Coming": "Thank You For Coming",
    "Tabel X Order has been checked out":
      "Tabel {X} Order has been checked out",
    "We hope to serve you again next time":
      "We hope to serve you again next time",
    "The payment has been received": "The payment has been received",
    "View membership benefits": "View membership benefits",
    "Join Member To Enjoy Benefits": "Join Member To Enjoy Benefits",
    Check: "Check",
    "Join Member": "Join Member",
    "X Minutes before last order": "{X} Minutes before last order",
    "Your last food order has not been delivered yet":
      "Your last food order has not been delivered yet",
    "Send out food order": "Send out food order",
    "X times order": "{X} times order",
    "Table No.": "Table No.",
    Pending: "Pending",
    Notice: "Notice",
    "Food are not available now": "Food are not available now",
    pc: "/pc",
    "I have read, understood and agreed to the above terms and conditions":
      "I have read, understood and agreed to the above terms and conditions",
    Confirm: "Confirm",
    "Please select the number of guests": "Please select the number of guests",
    "Save to Album": "Save to Album",
    Cancel: "Cancel",
    "Order payment voucher, please keep it properly":
      "Order payment voucher, please keep it properly",
    升级: "Upgrade",
    点餐: "Menu",
    The_self_fetching_function_is_not_available_please_contact_the_merchant:
      "The self-fetching function is not available, please contact the merchant.",
    The_delivery_function_is_not_available_please_contact_the_merchant:
      "The delivery function is not available, please contact the merchant.",
    Table_name: "Table name:",
    Person: "Person",
    My_order: "My order",
    loading_in: "Loading...",
    No_order_at_present: "No order at present",
    Opening_time: "Opening time",
    Unbind: "Unbind",
    LastOrderTime: "Last order time",
    EndTime: "End time",
    appTotal: "Total",
    Bill_Decimal: "Bill Decimal",
    appDiscount: "Discount",
    Service_amount: "Service amount",
    appAmount: "Amount",
    距离X米: "距离{X}米",
    自取: "Self pick up",
    外送: "Delivery",
    已售X份: "Sold {X} each",
    ONE_remaining: "{X} remaining",
    Amount: "Subtotal",
    Also_need_to_click_$ONE_food: "Also need to click {X} food",
    Next: "Next",
    Remaining_QS: "{X} Remaining",
    shopCartN: "Food selected",
    Empty: "Clear all",
    Share: "Share",
    Share_the_qr_Code: "Share the qr Code",
    大字版: "Large",
    Choose_a_language: "Choose a language",
    Logout: "Logout",
    Login: "Login",
    Not_logged_in: "Not logged in",
    Shop_Menu: "Menu", // 餐牌
    Cold_Chain_Delivery: "Cold Chain Delivery",
    Takeout: "Delivery",
    Pick_up: "Self pick up",
    Warm_prompt: "Reminder",
    Max_Number: "The maximum limit has been reached!",
    Over_maximum_order_quantity: "Over maximum order quantity",
    Shop_closed: "Shop closed",
    商户繁忙中: "Shop in Busy, delivery service not available in this moment",
    服务未开启: "Service not available at the moment",
    Takeaway_service_is_not_open: "Takeaway service is not open",
    Not_in_the_scope_of_delivery: "Not in the scope of delivery",
    Empty_cart: "Are you sure to clear all the items in cart?",
    Please_quit_and_try_again: "Please quit and try again!",
    UnbindSuccess: "Unbundling success!",
    关闭: "Close",
    结算: "Settlement",
    餐盒费: "Lunch box fee",
    共X份: "Total {X} copies",
    立即支付: "Pay now",
    送单成功: "Order delivered successfully!",
    确认门店地址: "Confirm store address",
    店铺: "Shop:",
    营业时间: "Business Hours:",
    地址: "Address:",
    可加購X份: "add {X} copies",
    加購以下商品享折扣: "Add purchase to enjoy discounts",
    返回: "Back",
    撞:"Combo",
    減:"-",
    此食品不參與折扣:"This food item is not eligible for discounts.",
    返回首頁將清空購物車是否返回: "Returning to the homepage will clear your shopping cart. Do you want to return?",
  },
};
